"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
        },
        backgroundRoot: {
            position: 'absolute',
            top: 0,
            left: 0,
        },
        backgroundCircle: {
            color: theme.palette.grey[200],
        },
        backgroundCircleDark: {
            color: theme.palette.grey[300],
        },
        ring: {
            position: 'absolute',
            strokeLinecap: 'round',
            top: 0,
            left: 0,
        },
    });
});
var CircularProgress = function (_a) {
    var className = _a.className, contrast = _a.contrast, _b = _a.size, size = _b === void 0 ? 40 : _b, _c = _a.thickness, thickness = _c === void 0 ? 5 : _c, _d = _a.variant, variant = _d === void 0 ? 'static' : _d, other = __rest(_a, ["className", "contrast", "size", "thickness", "variant"]);
    var classes = exports.useStyles();
    var showBackground = ['static', 'determinate'].includes(variant);
    return (react_1.default.createElement("div", { className: classes.root, style: {
            height: size,
            width: size,
        } },
        showBackground && (react_1.default.createElement(core_1.CircularProgress, __assign({}, other, { classes: {
                root: classes.backgroundRoot,
                circle: contrast
                    ? classes.backgroundCircleDark
                    : classes.backgroundCircle,
            }, size: size, thickness: thickness, variant: variant, value: 100 }))),
        react_1.default.createElement(core_1.CircularProgress, __assign({}, other, { className: clsx_1.default(classes.ring, className), size: size, thickness: thickness, variant: variant }))));
};
exports.default = CircularProgress;
//# sourceMappingURL=CircularProgress.js.map